module.exports = __webpack_public_path__ + "static/media/light-trezor.2024675b.svg";